import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
} from '@angular/material/dialog';
import { SharedModule } from '../../shared.module';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { AgePickerDialogComponent } from './age-picker-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [AgePickerDialogComponent],
    imports: [
        SharedModule,
        MatDialogModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatFormFieldModule,
        MatIconModule,
        MatDatepickerModule,
        TranslateModule
    ],
    exports: [AgePickerDialogComponent],
})
export class AgePickerDialogModule { }
